import React from "react";
import "../../../components/AppHeaderBar.css";
import "./HeaderAdmin.css";

const HeaderAdmin = () => {
  const Cookies = require("js-cookie");

  const handleLogout = () => {
    Cookies.remove("access_token");
    window.location.reload();
  };

  return (
    <header className="app-header-bar app-header-bar--admin" role="banner">
      <div className="app-header-bar__user-pill app-header-bar__user-pill--admin">
        <span className="app-header-bar__username">Quản trị</span>
      </div>
      <div className="app-header-bar__right">
        <button
          type="button"
          className="app-header-bar__logout"
          onClick={handleLogout}
        >
          Đăng xuất
        </button>
      </div>
    </header>
  );
};

export default HeaderAdmin;
